import { AllowedCompany } from '../../../../store/rtk-query/apis/onboarding/dto/response/get-allowed-companies.response';
import { ASSETS } from '../../../../assets';
import STRING_KEYS from '../../../../language/keys';

export const ROLES = {
  RECRUITER_FOR_OWN_COMPANY: 'MANAGER',
  OTHER_TEAMS_IN_MY_COMPANY: 'TEAM',
  RECRUITER_FOR_OTHER_COMPANIES: 'AGENCY',
};

export const ROLES_OPTIONS = [
  { value: ROLES.RECRUITER_FOR_OWN_COMPANY, transKey: STRING_KEYS.ONBOARDING.FORM.RECRUITING_FOR.OPTIONS.TITLES.OWN_COMPANY },
  { value: ROLES.OTHER_TEAMS_IN_MY_COMPANY, transKey: STRING_KEYS.ONBOARDING.FORM.RECRUITING_FOR.OPTIONS.TITLES.OTHER_TEAMS_IN_MY_COMPANY },
  {
    value: ROLES.RECRUITER_FOR_OTHER_COMPANIES,
    transKey: STRING_KEYS.ONBOARDING.FORM.RECRUITING_FOR.OPTIONS.TITLES.OTHER_COMPANIES,
  },
];

export const ROLES_SUBTITLES = {
  [ROLES.RECRUITER_FOR_OWN_COMPANY]: STRING_KEYS.ONBOARDING.FORM.RECRUITING_FOR.OPTIONS.SUBTITLES.OWN_COMPANY,
  [ROLES.OTHER_TEAMS_IN_MY_COMPANY]: STRING_KEYS.ONBOARDING.FORM.RECRUITING_FOR.OPTIONS.SUBTITLES.OTHER_TEAMS_IN_MY_COMPANY,
  [ROLES.RECRUITER_FOR_OTHER_COMPANIES]: STRING_KEYS.ONBOARDING.FORM.RECRUITING_FOR.OPTIONS.SUBTITLES.OTHER_COMPANIES,
};

export const CUSTOM_COMPANY: AllowedCompany = {
  id: 'Other',
  name: 'Other',
  linkedInUrl: 'https://linkedin.com/company/goperfect-labs',
  sanitizedLinkedInUrl: 'linkedin.com/company/goperfect-labs',
  logoUrl: ASSETS.EXPERIENCE_FALLBACK,
};
